<script>
import { defineComponent, computed, inject } from "vue";
import SidebarRouteLink from "@kit/components/SidebarRouteLink.vue";
import NavMainSearch from "@kit/components/NavMainSearch.vue";
import SideNavDrawerBase from "@kit/components/SideNavDrawerBase.vue";
import { searchWidgetMobile, sideDrawer } from "@project/themes";
import IconButton from "@kit/components/IconButton.vue";
import Icon from "@kit/components/Icon.vue";
import { getCurrentYear } from "@kit/utils/Formats";
import { inBrowser } from "@kit/utils/EnvironmentHelper";
import { KitColor } from "@kit/utils/Colors";
import { cmsasset } from "@kit/utils/Formats";

export default defineComponent({
  name: "SizeNavDrawer",
  setup() {
    const hydrate = inject("hydrate");

    const { prefetch } = hydrate({
      prefetch: ["navAndFooter", "routes"],
    });

    //inspect with /gtfs-routes?pretty
    //return the routes and also add in some colors.
    const serviceAgencies = computed(() => {
      const navAndFooter =
        prefetch.value && prefetch.value.navAndFooter
          ? prefetch.value.navAndFooter
          : null;

      const gtfsRoutes = prefetch.value?.routes;

      if (navAndFooter && gtfsRoutes) {
        const agencyArr = navAndFooter.routes_and_services;

        const colors = {};
        gtfsRoutes.forEach((route) => {
          colors[route.route_id] = route;
        });

        // We're going to skip this for aria.
        for (let i = 0; i < agencyArr.length; i++) {
          const agency = agencyArr[i];
          const { use_route_color_id, color, text_color } = agency;

          let bColor = "#FFFFFF";
          let tColor = "#333333";

          //If we're supposed to use one of the route colors for the service-agency colors,
          //then use it.
          if (use_route_color_id) {
            const r = colors[use_route_color_id];
            if (r) {
              const { aria_color, aria_text_color } = r;
              bColor = aria_color;
              tColor = aria_text_color;
            }
          }

          //else, just use the override color from the agency
          else {
            bColor = color;
            tColor = text_color;
          }

          agency["final_text_color"] = tColor;
          agency["final_color"] = bColor;
        }

        return agencyArr;
      }

      return [];
    });

    //inspect with /gtfs-routes?pretty
    //return the routes and also add in some colors.
    // const routes = computed(() => {
    //   const r =
    //     prefetch.value && prefetch.value.navAndFooter
    //       ? prefetch.value.navAndFooter
    //       : null;

    //   if (r) {
    //     const serviceArr = r.routes_and_services;

    //     for (let i = 0; i < serviceArr.length; i++) {
    //       const route = serviceArr[i];
    //       const color = KitColor.fromCSS(route.color);
    //       route["hoverColor"] = color.css();
    //       route["regularColor"] = color
    //         .clone()
    //         .hsvDelta({ ds: -0.2, dv: -0.2 }, true)
    //         .css();
    //     }

    //     return serviceArr;
    //   }

    //   return [];
    // });

    // const handleNavMouseOver = (e) => {
    //   const el = e.target.parentNode;
    //   el.style.backgroundColor = el.getAttribute("data-hoverColor");
    // };
    // const handleNavMouseOut = (e) => {
    //   const el = e.target.parentNode;
    //   el.style.backgroundColor = el.getAttribute("data-regularColor");
    // };

    return {
      searchWidgetMobile,
      sideDrawer,
      getCurrentYear,
      inBrowser,
      serviceAgencies,
      cmsasset,
    };
  },
  components: {
    SideNavDrawerBase,
    SidebarRouteLink,
    NavMainSearch,
    IconButton,
    Icon,
  },
});
</script>

<style>
.hamburger-button {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 20px;
  border-top: 4px solid #ffffff;
  border-bottom: 4px solid #ffffff;
  width: 50px;
  height: 30px;
  cursor: pointer;
}

.hamburger-button::after {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 4px;
  left: 0;
  right: 0;
  background: #ffffff;
}

.hta-side-nav-drawer {
  background: var(--green-blue);
  opacity: 1;
}

.hta-sidenav-item > a {
  color: white;
  font-size: 1.5rem !important;
}
.hta-sidenav-copyright {
  color: white;
  font-size: 1.2rem;
}
</style>

<template>
  <SideNavDrawerBase :theme="sideDrawer">
    <template #nav-items="{ active }">
      <div class="sb hta-sidenav-item">
        <SidebarRouteLink to="/fares/purchase-tickets-online/"> Fares </SidebarRouteLink>
      </div>

      <div class="sb hta-sidenav-item">
        <SidebarRouteLink to="/how-to-ride"> How to Ride </SidebarRouteLink>
      </div>

      <div class="sb hta-sidenav-item">
        <SidebarRouteLink to="/fares"> Fares &amp; Passes </SidebarRouteLink>
      </div>

      <h3
        class="sb sb-text"
        style="
          color: white;
          text-decoration: underline;
          font-weight: bold;
          margin-bottom: 5px;
        "
      >
        Routes:
      </h3>

      <template v-if="serviceAgencies.length > 0">
        <SidebarRouteLink
          v-for="agency in serviceAgencies"
          class="sb"
          :to="agency.url ? agency.url : `/agencies/${agency.url_slug}`"
          :style="`color:${agency.final_text_color}; background-color:${agency.final_color}; padding:10px; margin-top:0px;`"
        >
          {{ agency.display_name }}
        </SidebarRouteLink>
      </template>

      <div class="sb hta-sidenav-item">
        <SidebarRouteLink to="/contact-us"> Contact </SidebarRouteLink>
      </div>

      <div class="sb hta-sidenav-item">
        <SidebarRouteLink to="/news"> News </SidebarRouteLink>
      </div>

      <div
        class="sb sb-h sb-greedy-1"
        style="padding-right: 20px"
        id="translate-widget-container-mobile"
      >
        <Icon
          class="sb sb-text"
          width="4rem"
          :from-project="false"
          height="4em"
          style="fill: #ffffff"
          icon="translation"
        />
      </div>

      <NavMainSearch :theme="searchWidgetMobile" :active="active" />

      <div class="sb sb-text hta-sidenav-copyright">
        © {{ getCurrentYear() }} HTA. All rights reserved
      </div>
    </template>
  </SideNavDrawerBase>
</template>
